export function cssSelect(selector: string): string | undefined {
  try {
    const e = document.querySelector(selector) as HTMLElement
    if (e) {
      return (e.innerText || '').trim()
    }
  } catch {
    //
  }
}
